import {FC,} from "react";
import {Route} from "react-router-dom";
import {Navigate, Routes} from "react-router";
import {LoanManagerProjectAllocationFormPage} from "./Form";


export const LoanManagerProjectAllocationPage: FC = () => {
  return (
      <Routes>
        <Route index element={<LoanManagerProjectAllocationFormPage/>}/>
        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Routes>
  );
}


